module.exports = __webpack_public_path__ + "static/media/ooppah_play.eef5c84a.png";